import { useState } from 'react'
import { VITE_API_BASE } from '../config/apiConfig'

const API = VITE_API_BASE

const TEMPLATES = [
  { id: 1, name: '招生宣传', icon: '📢', duration: '30秒', scenes: 5, desc: '适合机构招生推广' },
  { id: 2, name: '活动回顾', icon: '🎉', duration: '60秒', scenes: 8, desc: '记录活动精彩瞬间' },
  { id: 3, name: '课程介绍', icon: '📚', duration: '45秒', scenes: 6, desc: '介绍课程特色' },
  { id: 4, name: '节日祝福', icon: '🎊', duration: '20秒', scenes: 4, desc: '节日问候短片' },
  { id: 5, name: '学员风采', icon: '📸', duration: '40秒', scenes: 6, desc: '展示学员成果' },
  { id: 6, name: '品牌故事', icon: '🎬', duration: '90秒', scenes: 10, desc: '讲述品牌故事' },
]

const MATERIALS = [
  { name: 'banner1.jpg', type: '背景', size: '2.4MB' },
  { name: 'logo.png', type: 'Logo', size: '156KB' },
  { name: 'music_bg.mp3', type: '音乐', size: '3.2MB' },
]

export default function AISmartEdit() {
  const [step, setStep] = useState(1)
  const [template, setTemplate] = useState(null)
  const [title, setTitle] = useState('')
  const [texts, setTexts] = useState([])
  const [generating, setGenerating] = useState(false)
  const [progress, setProgress] = useState(0)
  const [result, setResult] = useState(null)

  const handleGenerate = () => {
    setGenerating(true)
    setProgress(0)
    const interval = setInterval(() => {
      setProgress(p => {
        if (p >= 100) {
          clearInterval(interval)
          setGenerating(false)
          setResult({ url: '/cms/api/ai-videos/proxy/video?path=videos/ai_edit_result.mp4', thumbnail: '' })
          return 100
        }
        return p + 5
      })
    }, 200)
  }

  return (
    <div>
      <h2 style={{ fontSize: 20, marginBottom: 20 }}>✂️ AI智能剪辑</h2>
      <p style={{ color: '#666', marginBottom: 24 }}>为机构制作营销宣传视频，产出视频将发布到内容发布模块</p>

      {/* Steps */}
      <div style={{ display: 'flex', gap: 8, marginBottom: 24 }}>
        {['选择模板', '填写内容', '生成视频'].map((s, i) => (
          <div key={i} style={{
            padding: '10px 20px',
            borderRadius: 20,
            background: step > i + 1 ? '#52c41a' : step === i + 1 ? '#1890ff' : '#faad14',
            color: step > i + 1 ? '#fff' : step === i + 1 ? '#fff' : '#666',
            fontSize: 13
          }}>
            {step > i + 1 ? '✓' : `${i + 1}. `}{s}
          </div>
        ))}
      </div>

      {/* Step 1: Template */}
      {step === 1 && (
        <div>
          <h3 style={{ fontSize: 16, marginBottom: 16 }}>选择视频模板</h3>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 16 }}>
            {TEMPLATES.map(t => (
              <div
                key={t.id}
                onClick={() => setTemplate(t)}
                style={{
                  padding: 20,
                  background: '#fff',
                  borderRadius: 8,
                  cursor: 'pointer',
                  border: template?.id === t.id ? '2px solid #1890ff' : '2px solid transparent',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.06)'
                }}
              >
                <div style={{ fontSize: 40, marginBottom: 12 }}>{t.icon}</div>
                <div style={{ fontSize: 15, fontWeight: 500, marginBottom: 4 }}>{t.name}</div>
                <div style={{ fontSize: 12, color: '#666', marginBottom: 8 }}>{t.desc}</div>
                <div style={{ display: 'flex', gap: 12, fontSize: 11, color: '#666' }}>
                  <span>⏱️ {t.duration}</span>
                  <span>🎬 {t.scenes}场景</span>
                </div>
              </div>
            ))}
          </div>
          <div style={{ marginTop: 24, textAlign: 'right' }}>
            <button
              onClick={() => setStep(2)}
              disabled={!template}
              style={{ padding: '12px 32px', background: template ? '#1890ff' : '#ccc', color: '#fff', border: 'none', borderRadius: 6, cursor: template ? 'pointer' : 'not-allowed', fontSize: 14 }}
            >
              下一节</button>
          </div>
        </div>
      )}

      {/* Step 2: Content */}
      {step === 2 && (
        <div>
          <h3 style={{ fontSize: 16, marginBottom: 16 }}>填写视频内容</h3>
          <div style={{ background: '#fff', borderRadius: 8, padding: 24 }}>
            <div style={{ marginBottom: 20 }}>
              <label style={{ display: 'block', marginBottom: 8, fontWeight: 500 }}>视频标题</label>
              <input
                value={title}
                onChange={e => setTitle(e.target.value)}
                placeholder="请输入视频标题，如：中秋会员答谢活动"
                style={{ width: '100%', padding: '12px', border: '1px solid #d9d9d9', borderRadius: 4, fontSize: 14 }}
              />
            </div>

            <div style={{ marginBottom: 20 }}>
              <label style={{ display: 'block', marginBottom: 8, fontWeight: 500 }}>场景文字（最多{template?.scenes || 5}个）</label>
              {texts.map((t, i) => (
                <input
                  key={i}
                  value={t}
                  onChange={e => {
                    const newTexts = [...texts]
                    newTexts[i] = e.target.value
                    setTexts(newTexts)
                  }}
                  placeholder={`场景${i + 1}文字`}
                  style={{ width: '100%', padding: '12px', border: '1px solid #d9d9d9', borderRadius: 4, fontSize: 14, marginBottom: 8 }}
                />
              ))}
              <button onClick={() => setTexts([...texts, ''])} style={{ padding: '8px 16px', background: '#f5f5f5', border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: 12, color: '#666' }}>
                + 添加场景
              </button>
            </div>

            <div style={{ marginBottom: 20 }}>
              <label style={{ display: 'block', marginBottom: 8, fontWeight: 500 }}>素材</label>
              <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
                {MATERIALS.map((m, i) => (
                  <div key={i} style={{ padding: '8px 12px', background: '#f5f5f5', borderRadius: 4, fontSize: 12 }}>
                    📎 {m.name} <span style={{ color: '#999' }}>({m.size})</span>
                  </div>
                ))}
                <button style={{ padding: '8px 12px', border: '1px dashed #d9d9d9', borderRadius: 4, background: 'transparent', cursor: 'pointer', fontSize: 12, color: '#666' }}>
                  + 上传素材
                </button>
              </div>
            </div>
          </div>

          <div style={{ marginTop: 24, display: 'flex', justifyContent: 'space-between' }}>
            <button onClick={() => setStep(1)} style={{ padding: '12px 32px', background: '#fff', color: '#666', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 14 }}>
              上一节</button>
            <button
              onClick={() => setStep(3)}
              disabled={!title}
              style={{ padding: '12px 32px', background: title ? '#1890ff' : '#ccc', color: '#fff', border: 'none', borderRadius: 6, cursor: title ? 'pointer' : 'not-allowed', fontSize: 14 }}
            >
              生成视频
            </button>
          </div>
        </div>
      )}

      {/* Step 3: Generate */}
      {step === 3 && (
        <div>
          <h3 style={{ fontSize: 16, marginBottom: 16 }}>生成视频</h3>
          <div style={{ background: '#fff', borderRadius: 8, padding: 40, textAlign: 'center' }}>
            {generating ? (
              <div>
                <div style={{ fontSize: 48, marginBottom: 16 }}>🎬</div>
                <div style={{ fontSize: 16, marginBottom: 16 }}>视频生成中，请稍候...</div>
                <div style={{ width: '60%', height: 8, background: '#f5f5f5', borderRadius: 4, margin: '0 auto 8px', overflow: 'hidden' }}>
                  <div style={{ width: `${progress}%`, height: '100%', background: '#1890ff', transition: 'width 0.2s' }} />
                </div>
                <div style={{ color: '#999', fontSize: 13 }}>{progress}%</div>
              </div>
            ) : result ? (
              <div>
                <div style={{ fontSize: 48, marginBottom: 16 }}>✅</div>
                <div style={{ fontSize: 16, marginBottom: 16, color: '#52c41a' }}>视频生成完成！</div>
                <div style={{ height: 200, background: '#f5f5f5', borderRadius: 8, marginBottom: 16, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <span style={{ fontSize: 48 }}>▶️</span>
                </div>
                <div style={{ display: 'flex', gap: 12, justifyContent: 'center' }}>
                  <button style={{ padding: '10px 24px', background: '#1890ff', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer' }}>预览视频</button>
                  <button style={{ padding: '10px 24px', background: '#52c41a', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer' }}>发布到视频库</button>
                  <button onClick={() => { setStep(1); setResult(null); setTitle(''); setTexts([]) }} style={{ padding: '10px 24px', background: '#f5f5f5', color: '#666', border: 'none', borderRadius: 4, cursor: 'pointer' }}>新建任务</button>
                </div>
              </div>
            ) : (
              <div>
                <div style={{ fontSize: 48, marginBottom: 16 }}>📹</div>
                <div style={{ fontSize: 16, marginBottom: 16 }}>模板: {template?.name}</div>
                <div style={{ fontSize: 14, color: '#666', marginBottom: 24 }}>标题: {title}</div>
                <button onClick={handleGenerate} style={{ padding: '12px 32px', background: '#1890ff', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 14 }}>
                  开始生成</button>
              </div>
            )}
          </div>

          {!generating && !result && (
            <div style={{ marginTop: 24, textAlign: 'left' }}>
              <button onClick={() => setStep(2)} style={{ padding: '12px 32px', background: '#fff', color: '#666', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 14 }}>
                上一节</button>
            </div>
          )}
        </div>
      )}
    </div>
  )
}
